<template>
  <div>
    <v-alert v-if="error" type="error">{{ error.message }}</v-alert>

    <v-menu offset-y>
      <template v-slot:activator="{ on }">
        <v-btn icon v-on="on">
          <span>{{ lang }}</span>
        </v-btn>
      </template>

      <v-list>
        <v-list-item
          v-for="language in languages"
          :key="language.locale"
          @click="changeLocale(language.locale)"
        >
          <v-list-item-title>{{ language.title }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
export default {
  data: () => ({
    lang:
      localStorage.getItem('locale') || process.env.VUE_APP_I18N_LOCALE || 'de',
    error: null,

    languages: [
      {
        locale: 'en',
        title: 'English'
      },
      {
        locale: 'de',
        title: 'Deutsch'
      }
    ]
  }),

  methods: {
    changeLocale(locale) {
      localStorage.setItem('locale', locale);
      this.$vuetify.lang.current = locale;
      this.$i18n.locale = locale;

      this.$store
        .dispatch('user/updateLanguageApp', {
          user_app_locale: locale
        })
        .then(() => {
          this.$store.commit('localization/lang', locale);
        })
        .catch(error => {
          this.error = error.response;
        });

      this.lang = locale;
    }
  }
};
</script>
